import { cn } from '@ui/lib/utils';
import { forwardRef } from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}

const CardComponent = forwardRef<HTMLDivElement, CardProps>(({ className, hover, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-lg border border-gray-200 bg-white shadow-sm',
        hover && 'transition-shadow hover:shadow-md',
        className
      )}
      {...props}
    />
  )
})

CardComponent.displayName = 'Card'

export interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> { }

const CardHeader = forwardRef<HTMLDivElement, CardHeaderProps>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />
})

CardHeader.displayName = 'CardHeader'

export interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> { }

const CardBody = forwardRef<HTMLDivElement, CardBodyProps>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn('p-3 pt-0', className)} {...props} />
})

CardBody.displayName = 'CardBody'

export interface CardFooterProps extends React.HTMLAttributes<HTMLDivElement> { }

const CardFooter = forwardRef<HTMLDivElement, CardFooterProps>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn('flex items-center p-3 pt-0', className)} {...props} />
})

CardFooter.displayName = 'CardFooter'

// Create compound component
export const Card = CardComponent as typeof CardComponent & {
  Header: typeof CardHeader
  Body: typeof CardBody
  Footer: typeof CardFooter
}

// Attach subcomponents to Card
Card.Header = CardHeader
Card.Body = CardBody
Card.Footer = CardFooter
